/**
 * Color de los recuadros de ícono y badges de Desempeño. El terciario manda, pero un
 * terciario neutro (negro, blanco o gris: Aprendizaje deja #000000 por defecto) pintaría
 * los recuadros de gris; entonces se usa el secundario, y si también es neutro, el primario.
 */
const HEX = /^#[0-9a-fA-F]{6}$/;

function hasColor(hex: string | null | undefined): boolean {
	if (!hex || !HEX.test(hex)) return false;

	const [r, g, b] = [1, 3, 5].map((start) => parseInt(hex.slice(start, start + 2), 16) / 255);
	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);
	const lightness = (max + min) / 2;

	if (lightness < 0.12 || lightness > 0.92) return false;

	const saturation = (max - min) / (1 - Math.abs(2 * lightness - 1));

	return saturation >= 0.2;
}

export function performanceAccent(primary: string, secondary: string | null, tertiary: string | null): string {
	return [tertiary, secondary].find((color) => hasColor(color)) ?? primary;
}
